import { lazy, Suspense, type ReactNode } from 'react';
import type { RouteObject } from 'react-router';
import { PageSkeleton } from '../../components/Page';

const ProductsPage = lazy(() => import('./pages/ProductsPage'));
const ProductFormPage = lazy(() => import('./pages/ProductFormPage'));
const MovementsPage = lazy(() => import('./pages/MovementsPage'));
const CategoriesPage = lazy(() => import('./pages/CategoriesPage'));
const VariationsPage = lazy(() => import('./pages/VariationsPage'));

const page = (el: ReactNode) => <Suspense fallback={<PageSkeleton />}>{el}</Suspense>;

/** Rotas desta área (dentro do shell autenticado). */
export const routes: RouteObject[] = [
  { path: 'produtos', element: page(<ProductsPage />) },
  { path: 'produtos/novo', element: page(<ProductFormPage />) },
  { path: 'produtos/categorias', element: page(<CategoriesPage />) },
  { path: 'produtos/variacoes', element: page(<VariationsPage />) },
  { path: 'produtos/:id', element: page(<ProductFormPage />) },
  { path: 'produtos/:id/movimentacoes', element: page(<MovementsPage />) },
];

/** Rotas protegidas sem o shell (ex.: impressão). */
export const fullscreenRoutes: RouteObject[] = [];
